import { Path, PathValue, UseFormReturn } from "react-hook-form";
import { AddExhibitorFormValues } from "view/apps/Organiser/pages/Show/Exhibitors/components/AddExhibitorModal/types";
import { useEffect } from "react";

const useStandAreaCalculation = <
  T extends Pick<
    AddExhibitorFormValues,
    "isIrregularSelected" | "standWidth" | "standLength" | "irregularArea"
  >
>(
  form: UseFormReturn<T>
) => {
  const { watch, setValue } = form;
  const { standLength, standWidth, isIrregularSelected } = watch();
  useEffect(() => {
    if (isIrregularSelected) {
      return;
    }
    const area =
      standLength && standWidth
        ? Number((standLength * standWidth).toFixed(2))
        : null;
    if (!area) {
      return;
    }
    setValue("irregularArea" as Path<T>, area as PathValue<T, Path<T>>, {
      shouldValidate: true,
    });
  }, [standWidth, standLength, isIrregularSelected, setValue]);
};
export default useStandAreaCalculation;
